import { render } from "./ProfilManagement.vue?vue&type=template&id=f9b689c4"
import script from "./ProfilManagement.vue?vue&type=script&lang=js"
export * from "./ProfilManagement.vue?vue&type=script&lang=js"

import "./ProfilManagement.vue?vue&type=style&index=0&id=f9b689c4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__